import { ReviewsSectionOrganism } from '../modules/organisms/reviews-section';
import { useWindow } from '../effects';
import { FooterPartial, HeaderPartial } from '../components';
import { useBridgePageEffect } from '../hooks';

const ReviewsPage = () => {
  const announcement = false;
  const bodyTop = announcement ? 'bodyTopDefault' : 'bodyTopAnnouncement';
  useWindow();

  const bridge = useBridgePageEffect({
    isAccount: false,
    condensedFooter: false,
  });

  return (
    <>
      <HeaderPartial {...bridge.header}></HeaderPartial>
      <main role="main" className={bodyTop}>
        <ReviewsSectionOrganism />
      </main>
      <FooterPartial {...bridge.footer}></FooterPartial>
    </>
  );
};

export default ReviewsPage;
